export const USER_SIGNUP_REQUEST="USER_SIGNUP_REQUEST";
export const USER_SIGNUP_SUCCESS="USER_SIGNUP_SUCCESS";
export const USER_SIGNUP_FAILURE="USER_SIGNUP_FAILURE";

export const USER_LOGIN_REQUEST="USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS="USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILURE="USER_LOGIN_FAILURE";

export const USER_LOGOUT_REQUEST="USER_LOGOUT_REQUEST";
export const USER_LOGOUT_SUCCESS="USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_FAILURE="USER_LOGOUT_FAILURE";


export const USER_FULLNAME="USER_FULLNAME";